import type Quill from 'quill/core';
import type { Parchment } from 'quill/core';
import React from 'react';
import { MenuItem } from '../../components/Menu';
import cardIcon from '../../icons/non-prefilled/16x16/card.svg';
import replaceEmbedBlotWith from '../utils/replaceEmbedBlotWith';

interface ConvertIntoCardMenuItemProps {
  quill: Quill;
  blot: Parchment.EmbedBlot;
}

const ConvertIntoCardMenuItem = ({
  quill,
  blot,
}: ConvertIntoCardMenuItemProps) => (
  <MenuItem
    icon={cardIcon}
    onClick={() => {
      const { id, type, params } = blot.statics.value(blot.domNode);
      replaceEmbedBlotWith(quill, blot, {
        card: { type, id, params },
      });
    }}
    testId="convertIntoCardMenuItem"
  >
    Convert into card
  </MenuItem>
);

export default ConvertIntoCardMenuItem;
